var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRouteActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.226 25.91 c 11.153 0 20.226 9.073 20.226 20.226 c 0 4.776 -1.707 9.417 -4.805 13.069 L 22.226 77.367 L 6.805 59.205 C 3.707 55.553 2 50.912 2 46.136 C 2 34.983 11.073 25.91 22.226 25.91 M 22.226 56.511 c 6.143 0 11.141 -4.998 11.141 -11.141 c 0 -6.143 -4.998 -11.141 -11.141 -11.141 s -11.141 4.998 -11.141 11.141 C 11.085 51.514 16.083 56.511 22.226 56.511 M 22.226 23.91 C 9.951 23.91 0 33.861 0 46.136 c 0 5.48 1.992 10.488 5.28 14.363 l 16.946 19.958 l 16.946 -19.958 c 3.288 -3.875 5.28 -8.883 5.28 -14.363 C 44.452 33.861 34.501 23.91 22.226 23.91 L 22.226 23.91 z M 22.226 54.511 c -5.048 0 -9.141 -4.092 -9.141 -9.141 c 0 -5.048 4.092 -9.141 9.141 -9.141 c 5.048 0 9.141 4.092 9.141 9.141 C 31.366 50.419 27.274 54.511 22.226 54.511 L 22.226 54.511 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,133,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.845 11.543 C 81.201 11.543 88 18.341 88 26.698 c 0 3.578 -1.279 7.056 -3.6 9.792 L 72.845 50.099 L 61.29 36.49 c -2.322 -2.737 -3.601 -6.214 -3.601 -9.792 C 57.69 18.341 64.488 11.543 72.845 11.543 M 72.845 35.163 c 4.993 0 9.055 -4.062 9.055 -9.055 c 0 -4.993 -4.062 -9.055 -9.055 -9.055 s -9.055 4.062 -9.055 9.055 C 63.79 31.101 67.852 35.163 72.845 35.163 M 72.845 9.543 c -9.474 0 -17.155 7.681 -17.155 17.155 c 0 4.23 1.538 8.095 4.076 11.086 l 13.079 15.405 l 13.079 -15.405 C 88.462 34.793 90 30.928 90 26.698 C 90 17.223 82.319 9.543 72.845 9.543 L 72.845 9.543 z M 72.845 33.163 c -3.896 0 -7.055 -3.159 -7.055 -7.055 c 0 -3.896 3.159 -7.055 7.055 -7.055 s 7.055 3.159 7.055 7.055 C 79.9 30.004 76.741 33.163 72.845 33.163 L 72.845 33.163 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,133,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.127 81.457 h -0.373 v -2 h 0.373 c 1.239 0 2.432 -0.371 3.446 -1.072 l 1.137 1.645 C 80.36 80.964 78.775 81.457 77.127 81.457 z M 72.11 81.457 h -4.645 v -2 h 4.645 V 81.457 z M 62.822 81.457 h -4.645 v -2 h 4.645 V 81.457 z M 53.534 81.457 H 48.89 v -2 h 4.645 V 81.457 z M 44.246 81.457 h -4.644 v -2 h 4.644 V 81.457 z M 34.958 81.457 h -4.644 v -2 h 4.644 V 81.457 z M 84.813 75.85 l -1.904 -0.609 c 0.19 -0.596 0.287 -1.218 0.287 -1.852 c 0 -0.708 -0.121 -1.403 -0.36 -2.064 l 1.881 -0.68 c 0.318 0.88 0.479 1.804 0.479 2.744 C 85.195 74.229 85.066 75.058 84.813 75.85 z M 80.386 68.269 c -0.972 -0.62 -2.099 -0.948 -3.259 -0.948 h -0.634 v -2 h 0.634 c 1.542 0 3.041 0.437 4.335 1.263 L 80.386 68.269 z M 71.849 67.32 h -4.644 v -2 h 4.644 V 67.32 z M 62.561 67.32 h -4.408 c -0.092 0 -0.183 -0.001 -0.272 -0.005 l 0.074 -1.998 l 0.198 0.003 h 4.408 V 67.32 z M 53.016 65.474 c -1.37 -1.132 -2.34 -2.705 -2.732 -4.43 l 1.951 -0.443 c 0.294 1.296 1.024 2.479 2.055 3.332 L 53.016 65.474 z M 52.642 56.707 l -1.814 -0.84 c 0.744 -1.607 2.02 -2.945 3.59 -3.768 l 0.928 1.771 C 54.162 54.49 53.202 55.497 52.642 56.707 z M 64.038 53.184 h -4.645 v -2 h 4.645 V 53.184 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,133,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteActive);
export default __webpack_public_path__ + "static/media/route-active.0f578676a11181d9483664ae13dc5d45.svg";
export { ForwardRef as ReactComponent };